import { createIcon } from '@chakra-ui/icons';

// hugeicons "sparkles" — the Hero section template. Exported from the Academies Figma file.
export const Sparkles = createIcon({
  displayName: 'Sparkles',
  viewBox: '0 0 14.5833 14.5833',
  path: (
    <>
      <path fill="none" d="M9.29167 0.625L9.65082 2.21938C9.95546 3.57177 11.0116 4.62787 12.3639 4.93251L13.9583 5.29167L12.3639 5.65082C11.0116 5.95546 9.95546 7.01157 9.65082 8.36395L9.29167 9.95833L8.93251 8.36395C8.62787 7.01156 7.57177 5.95546 6.21938 5.65082L4.625 5.29167L6.21938 4.93251C7.57177 4.62787 8.62787 3.57177 8.93251 2.21939L9.29167 0.625Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round"/>
      <path fill="none" d="M3.95833 7.29167L4.21487 8.43051C4.43247 9.3965 5.18683 10.1509 6.15282 10.3685L7.29167 10.625L6.15282 10.8815C5.18683 11.0991 4.43247 11.8535 4.21487 12.8195L3.95833 13.9583L3.70179 12.8195C3.48419 11.8535 2.72983 11.0991 1.76385 10.8815L0.625 10.625L1.76385 10.3685C2.72983 10.1509 3.4842 9.3965 3.7018 8.43051L3.95833 7.29167Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round"/>
    </>
  ),
});
